import Toast from 'react-native-toast-message';
import {useMutation} from '@tanstack/react-query';

import {ERROR_MESSAGE} from '../../components/ToastBottom';
import {useStores} from '../../stores/use-stores';
import apiService from '../../transport/apiService';

import {CartMutationParams} from './types';

/**
 * Mutation hook for updating cart item quantity.
 * Provides per-item loading state for CartButton components.
 *
 * @returns Mutation object with mutate function and loading state
 *
 * @example
 * const {mutate: updateCart, isPending} = useCartMutation();
 *
 * updateCart({
 *   productId: '123',
 *   quantity: 2
 * });
 */
export const useCartMutation = () => {
  const {cartStore} = useStores();

  return useMutation({
    mutationFn: async ({productId, quantity}: CartMutationParams) => {
      return apiService.changeOrderLines([{product_id: productId, quantity}]);
    },
    onSuccess: data => {
      cartStore.setCurrentOrderFromResponse(data);
      // DIS-1608 trigger 3: this path refreshed nothing before.
      cartStore.refreshCouponStatus();
    },
    onError: () => {
      Toast.show({
        type: ERROR_MESSAGE,
        text1: 'Unable to update cart. Please try again.',
      });
    },
  });
};
